import { PrestationFormatPreset } from '../prestation-presets';

export const PRESTATION_FORMAT_PRESET_LABEL_KEY = 'PRESTATION_FORMAT_PRESET_LABEL_';
export const PRESTATION_FORMAT_PRESET_DESC_KEY = 'PRESTATION_FORMAT_PRESET_DESC_';

const PRESETS: PrestationFormatPreset[] = ['SOLO', 'GROUPE', 'RENFORCE', 'SESSION', 'ATELIER', 'LIBRE_SERVICE'];

export const PrestationFormatPresetTranslation = {
  'fr-FR': {
    [`${PRESTATION_FORMAT_PRESET_LABEL_KEY}SOLO`]: 'Solo',
    [`${PRESTATION_FORMAT_PRESET_LABEL_KEY}GROUPE`]: 'Groupe',
    [`${PRESTATION_FORMAT_PRESET_LABEL_KEY}RENFORCE`]: 'Renforcé',
    [`${PRESTATION_FORMAT_PRESET_LABEL_KEY}SESSION`]: 'Session',
    [`${PRESTATION_FORMAT_PRESET_LABEL_KEY}ATELIER`]: 'Atelier',
    [`${PRESTATION_FORMAT_PRESET_LABEL_KEY}LIBRE_SERVICE`]: 'Libre-service',

    [`${PRESTATION_FORMAT_PRESET_DESC_KEY}SOLO`]: 'Un client servi par un membre (cas standard).',
    [`${PRESTATION_FORMAT_PRESET_DESC_KEY}GROUPE`]:
      'Une seule personne réserve pour tout le monde : les clients viennent ensemble (duo, famille, tablée).',
    [`${PRESTATION_FORMAT_PRESET_DESC_KEY}RENFORCE`]:
      'Un client servi par plusieurs membres en simultané (4 mains, binôme).',
    [`${PRESTATION_FORMAT_PRESET_DESC_KEY}SESSION`]:
      'Chaque participant réserve sa propre place sur un créneau commun (cours collectif, afterwork, événement).',
    [`${PRESTATION_FORMAT_PRESET_DESC_KEY}ATELIER`]:
      'Session collective animée par plusieurs membres en binôme ou en équipe.',
    [`${PRESTATION_FORMAT_PRESET_DESC_KEY}LIBRE_SERVICE`]:
      'Aucun membre mobilisé : disponibilité pilotée par la ressource (location, salle libre).',
  },
};

// Sanity check at module load — keeps labels in sync with the enum.
for (const preset of PRESETS) {
  const labelKey = `${PRESTATION_FORMAT_PRESET_LABEL_KEY}${preset}`;
  const descKey = `${PRESTATION_FORMAT_PRESET_DESC_KEY}${preset}`;
  if (!(labelKey in PrestationFormatPresetTranslation['fr-FR'])) {
    throw new Error(`Missing fr-FR translation for ${labelKey}`);
  }
  if (!(descKey in PrestationFormatPresetTranslation['fr-FR'])) {
    throw new Error(`Missing fr-FR translation for ${descKey}`);
  }
}
